import type { IconData } from '@stacksjs/iconify-core'

export const videoMoviesVideoSquare: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.48 3.05H32v25.9h-1.52Zm-1.53 25.9h1.53v1.52h-1.53Zm0-27.43h1.53v1.53h-1.53ZM3.05 30.47h25.9V32H3.05ZM25.9 12.19h1.53v7.62H25.9v1.52h3.05V10.66H25.9zm-1.52 6.09h1.52v1.53h-1.52Zm0-6.09h1.52v1.52h-1.52Zm-1.52 4.57v-1.52h1.52v-1.53h-1.52V9.14h-1.53v13.71h1.53v-4.57h1.52v-1.52zM4.57 22.85h16.76v1.53H4.57Zm1.52-9.14v7.62h12.2v-7.62Zm7.62 6.1h-1.52v-1.53h1.52Zm3.05 0h-1.52v-3.05h-6.1v3.05H7.62v-4.57h9.14Zm-7.62-9.15h1.53v1.53H9.14Zm-3.05 0h1.53v1.53H6.09ZM4.57 7.62h16.76v1.52H4.57ZM3.05 0h25.9v1.52H3.05Zm0 9.14h1.52v13.71H3.05ZM1.52 28.95h1.53v1.52H1.52Zm0-27.43h1.53v1.53H1.52ZM0 3.05h1.52v25.9H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default videoMoviesVideoSquare
